import z from 'zod';

const topicsBasePath = 'watchlist/v1/topics/';

const topicTypeZodEnum = z.enum(['theme', 'geography']);
export type TopicType = z.infer<typeof topicTypeZodEnum>;

export const getTopicsResponseSchema = z.object({
  values: z.array(z.string()),
});
export type GetTopicsResponse = z.infer<typeof getTopicsResponseSchema>;

export const getTopicResponseSchema = z.object({
  followed: z.boolean(),
});
export type GetTopicResponse = z.infer<typeof getTopicResponseSchema>;

export const topics = {
  getTopics: {
    path: (type: TopicType) => `${topicsBasePath}${type}`,
    schema: getTopicsResponseSchema,
  },
  getTopic: {
    path: (type: TopicType, code: string) => `${topicsBasePath}${type}/${code}`,
    schema: getTopicResponseSchema,
  },
  postTopic: {
    path: (type: TopicType, code: string) => `${topicsBasePath}${type}/${code}`,
    schema: getTopicsResponseSchema,
  },
  deleteTopic: {
    path: (type: TopicType, code: string) => `${topicsBasePath}${type}/${code}`,
    schema: getTopicsResponseSchema,
  },
};
